import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { assessmentApi } from '../../services/assessmentApi';
import { assessmentKeys } from './useGetAssessment';

export function useDeleteAssessment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => assessmentApi.deleteAssessment(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted assessment');
        queryClient.invalidateQueries({ queryKey: assessmentKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete assessment'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete assessment'}`);
    },
  });
}
